import { createTheme } from '@material-ui/core/styles';

const drawerWidth = 260;

export const theme = createTheme({
  palette: {
    primary: {
      main: '#E2725B',
    },
    secondary: {
      main: '#356C7C',
    },
    background: {
      default: '#ffffff',
      paper: '#F4ECE4',
    },
    text: {
      primary: '#333333',
      secondary: '#888888',
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
    fontSize: 12,
    button: {
      textTransform: 'none',
    },
  },
  overrides: {
    MuiOutlinedInput: {
      root: {
        backgroundColor: '#F4ECE4',
        '& $notchedOutline': {
          borderColor: '#E2725B',
        },
        '&:hover $notchedOutline': {
          borderColor: '#E2725B',
        },
        '&$focused $notchedOutline': {
          borderColor: '#356C7C',
        },
      },
      notchedOutline: {},
      focused: {},
    },
  },
});

export const useStyles = (theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24,
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
    marginTop: 15,
    marginBottom: 15
  },
  appBar: {
    zIndex: 1200,
    width: '100%',
    top: 0,
    left: 0,
    transition: theme.transitions.create(['left', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100%)`,
    transition: theme.transitions.create(['left', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuBarIcon: {
    padding: '8px 0 8px 8px'
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  perfilWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: '0px'
  },
  // 🆕 NOVOS ESTILOS
  drawerResponsive: {
    [theme.breakpoints.down('sm')]: {
      position: 'fixed',
      zIndex: theme.zIndex.drawer,
    },
  },
  appBarSpacer: {
    ...theme.mixins.toolbar,
    minHeight: '64px !important',
    height: '64px !important',
  },
  content: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '100vh',
    position: 'relative',
  },
  mainContent: {
    marginTop: '30px', // Espaço para o AppBar
    flexGrow: 1,
    overflow: 'auto',
    backgroundColor: theme.palette.background.default,
    position: 'relative',
    zIndex: 1,

    [theme.breakpoints.down('sm')]: {
      marginTop: '15px', // Remove o espaço para o AppBar em telas pequenas
    },

  },
  container: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(4),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    maxWidth: '100%',
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
  // 🆕 Estilos para Item Ativo
  activeItem: {
    backgroundColor: theme.palette.action.selected,
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    paddingLeft: 'calc(8px - 4px)',
    '& .MuiListItemIcon-root': {
      color: theme.palette.primary.main,
    },
    '& .MuiListItemText-primary': {
      fontWeight: 600,
      color: theme.palette.primary.main,
    },
  },
  inactiveItem: {
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
});